import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';

import styles from './Interact.module.less';
import _LogInView from '../../_LogInView/_LogInView';
import GameRate from '../GameRate/GameRate';
import Button from '../../Button/Button';
import { logging, logPostInfo } from '../../../actions/log';
import { CONTEXT } from '../../../config';
import { changeClass } from '../../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ soft, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);

  const [softVideoDom, setSoftVideo] = useState(null);
  const [imgDom, setImgDom] = useState(null);
  const [priceZKDom, setPriceZK] = useState(null);
  const [priceDom, setPrice] = useState(null);
  const [btnDom, setBtnDom] = useState(null);

  const handleSoftCard = useCallback(() => {
    const source = logInfo ? logInfo.source : 'SoftCard_err';
    dispatch(
      logging({
        category: 'C',
        action: 'handle_SoftCard',
        label: '',
        param2: {
          ...logInfo,
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
        param3: soft.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source_p: source,
        source_pp: logInfoData.source_p,
      }),
    );
    if (soft.androidType === '1') {
      history.push(
        `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo || '{}'}`,
      );
    } else {
      history.push(`${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}`);
    }
  });

  useEffect(() => {
    if (softVideoDom && soft?.card_show_style !== 'big') {
      changeClass(softVideoDom, styles.mouse_out, styles.mouse_in);
    }
    if (priceZKDom && priceDom) {
      changeClass(priceZKDom, styles.mouse_in, styles.mouse_out);
      changeClass(priceDom, styles.mouse_in, styles.mouse_out);
    }
    if (btnDom) {
      changeClass(btnDom, styles.mouse_out, styles.mouse_in);
    }
  }, [priceZKDom, priceDom, btnDom, softVideoDom]);

  const onMouseOver = useCallback(() => {
    if (priceZKDom) {
      changeClass(priceZKDom, styles.mouse_out, styles.mouse_in);
    }
    if (priceDom) {
      changeClass(priceDom, styles.mouse_out, styles.mouse_in);
    }
    if (btnDom) {
      changeClass(btnDom, styles.mouse_in, styles.mouse_out);
    }

    if (softVideoDom) {
      changeClass(softVideoDom, styles.mouse_in, styles.mouse_out);
      return;
    }
    if (imgDom) {
      changeClass(imgDom, styles.image_mouse_in, styles.image_mouse_out);
    }
  }, [priceZKDom, priceDom, btnDom, softVideoDom, imgDom]);

  const onMouseLeave = useCallback(() => {
    if (priceZKDom) {
      changeClass(priceZKDom, styles.mouse_in, styles.mouse_out);
    }
    if (priceDom) {
      changeClass(priceDom, styles.mouse_in, styles.mouse_out);
    }
    if (btnDom) {
      changeClass(btnDom, styles.mouse_out, styles.mouse_in);
    }

    if (softVideoDom) {
      changeClass(softVideoDom, styles.mouse_out, styles.mouse_in);
      return;
    }
    if (imgDom) {
      changeClass(imgDom, styles.image_mouse_out, styles.image_mouse_in);
    }
  }, [priceZKDom, priceDom, btnDom, softVideoDom, imgDom]);

  const formatPriceType3 = useCallback((num = '0') => {
    return parseFloat((num || '0')?.replace('¥', '').replace('￥', ''));
  }, []);
  const formatPrice = useCallback((num = '0') => {
    return `${parseFloat((parseInt(num) / 100).toFixed(2)) || 0}`;
  }, []);
  const formatPriceZK = useCallback((cu_, or_) => {
    let cu = parseFloat(cu_);
    let or = parseFloat(or_);
    if (cu && or) {
      return `${parseFloat((cu / or).toFixed(2)) * 10 || 0}`;
    }
    return '';
  }, []);

  return (
    <_LogInView cardData={soft} logInfo={logInfo}>
      <div
        className={soft?.card_show_style === 'big' ? styles.soft_item_big : styles.soft_item}
        onMouseOver={e => onMouseOver(e)}
        onMouseLeave={e => onMouseLeave(e)}
        onClick={handleSoftCard}
      >
        {soft?.ztImg || (soft?.captureFileList && soft?.captureFileList[0]) ? (
          <img
            className="soft_img"
            ref={r => setImgDom(r)}
            src={soft?.ztImg || (soft?.captureFileList && soft?.captureFileList[0])}
          />
        ) : (
          <div className="soft_img_"></div>
        )}

        {soft?.resUrl && (
          <div
            className={`soft_video ${soft?.card_show_style === 'big' && styles.mouse_in}`}
            ref={r => setSoftVideo(r)}
          >
            <img
              className={`soft_video_img`}
              src={
                soft?.resUrl || soft?.ztImg || (soft?.captureFileList && soft?.captureFileList[0])
              }
              alt=""
            />
          </div>
        )}

        <div className={`soft_bg`}>
          <div className={`soft_name_zk`}>
            <div className={`soft_name_box`}>
              <div className={`soft_name`}>{soft?.softName}</div>

              {soft?.androidType === '1' && <div className={`soft_point_and`}></div>}

              {soft?.androidType !== '1' && soft?.installFileType === 1 && (
                <div className={`soft_point_dlc`}></div>
              )}
            </div>
            {soft?.androidType === '3' &&
              soft?.sourceInfo &&
              soft?.sourceInfo?.sellInfo &&
              soft?.sourceInfo?.sellInfo?.discount && (
                <div className={`soft_price_zk`} ref={r => setPriceZK(r)}>
                  {soft?.sourceInfo?.sellInfo?.discount} 折
                </div>
              )}
            {soft?.payType === 1 &&
              soft?.currentPrice &&
              soft?.originalPrice &&
              soft?.currentPrice !== soft?.originalPrice && (
                <div className={`soft_price_zk`} ref={r => setPriceZK(r)}>
                  {formatPriceZK(soft?.currentPrice, soft?.originalPrice)} 折
                </div>
              )}
          </div>

          <div className={`soft_info_price`}>
            <div className={`soft_info`}>
              {false && soft?.card_show_style === 'big' && (
                <div className={`soft_rate`}>
                  <GameRate
                    score={parseInt(parseInt(soft?.score || 60) / 20)}
                    styleType={`white`}
                  />
                </div>
              )}
              <div className={`soft_dl`}>{`${soft.downloadCount}安装`}</div>
            </div>
            {soft?.androidType === '3' &&
              soft?.sourceInfo &&
              soft?.sourceInfo?.sellInfo &&
              (soft?.sourceInfo?.sellInfo?.currentPrice ||
                soft?.sourceInfo?.sellInfo?.originalPrice) && (
                <div className={`soft_price_co`} ref={r => setPrice(r)}>
                  {((soft?.sourceInfo?.sellInfo?.currentPrice &&
                    !soft?.sourceInfo?.sellInfo?.originalPrice) ||
                    (!soft?.sourceInfo?.sellInfo?.currentPrice &&
                      soft?.sourceInfo?.sellInfo?.originalPrice) ||
                    soft?.sourceInfo?.sellInfo?.currentPrice ===
                      soft?.sourceInfo?.sellInfo?.originalPrice) && (
                    <div className={`soft_price_c`}>
                      ¥
                      {formatPriceType3(
                        soft?.sourceInfo?.sellInfo?.currentPrice ||
                          soft?.sourceInfo?.sellInfo?.originalPrice,
                      )}
                    </div>
                  )}
                  {soft?.sourceInfo?.sellInfo?.currentPrice &&
                    soft?.sourceInfo?.sellInfo?.originalPrice &&
                    soft?.sourceInfo?.sellInfo?.currentPrice !==
                      soft?.sourceInfo?.sellInfo?.originalPrice && (
                      <>
                        <div className={`soft_price_c`}>
                          ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                        </div>
                        <div className={`soft_price_o`}>
                          ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}
                        </div>
                      </>
                    )}
                </div>
              )}
            {soft?.payType === 1 && (
              <div className={`soft_price_co`} ref={r => setPrice(r)}>
                {((!soft?.currentPrice && soft?.originalPrice) ||
                  (soft?.currentPrice && !soft?.originalPrice) ||
                  soft?.currentPrice === soft?.originalPrice) && (
                  <div className={`soft_price_c`}>
                    ¥{formatPrice(soft?.currentPrice || soft?.originalPrice)}
                  </div>
                )}
                {soft?.currentPrice &&
                  soft?.originalPrice &&
                  soft?.currentPrice !== soft?.originalPrice && (
                    <>
                      <div className={`soft_price_c`}>¥{formatPrice(soft?.currentPrice)}</div>
                      <div className={`soft_price_o`}>¥{formatPrice(soft?.originalPrice)}</div>
                    </>
                  )}
              </div>
            )}
          </div>
        </div>

        <div
          className={`soft_opt`}
          ref={r => setBtnDom(r)}
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          {soft?.card_show_style === 'big' ? (
            <Button
              soft={soft}
              info={{
                btnStyle: logInfo?.tag?.indexOf('Game_') > -1 ? 'opacity' : '',
                className: styles.soft_button_b,
                className_busing: styles.soft_button_busing_b,
                className_open: styles.button_open_b,
              }}
              logInfo={logInfo}
            />
          ) : (
            <Button
              soft={soft}
              info={{
                btnStyle: logInfo?.tag?.indexOf('Game_') > -1 ? 'opacity' : '',
                className: styles.soft_button,
                className_busing: styles.soft_button_busing,
                className_open: styles.button_open,
              }}
              logInfo={logInfo}
            />
          )}
        </div>
      </div>
    </_LogInView>
  );
});
